<template>
  <div class="signin-box">
    <div class="header">{{$t('btn.loginin')}}</div>
    <Form ref="form" :model="form" :rules="ruleForm" @submit.native.prevent>
      <FormItem prop="name">
        <i class="form-icon uid"></i>
        <Input type="text" v-model.trim="form.name" clearable @on-enter="ok" :placeholder="$t('account.login.uidPlaceholder')" />
      </FormItem>
      <FormItem prop="password" class="pwd">
        <i class="form-icon pwd"></i>
        <Input type="password" v-model.trim="form.password" clearable @on-enter="ok" :placeholder="$t('account.login.pwdPlaceholder')" />
      </FormItem>
      <FormItem prop="remember" class="clearfix">
        <Checkbox v-model="form.remember">{{$t('account.login.rememberPwd')}}</Checkbox>
      </FormItem>
    </Form>
    <div class="footer">
      <Button type="primary" :loading="isShowLoader" @click="ok">
        <span v-if="!isShowLoader"><span>{{$t('btn.loginin')}}</span></span>
        <span v-else>{{$t('btn.loginin')}}</span>
      </Button>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import { mapMutations } from 'vuex'

export default {
  name: 'LoginBoxZH',
  components: { Loader },
  data () {
    return {
      isSubmit: false,
      isShowLoader: false,
      form: {
        name: '',
        password: '',
        remember: true
      },
      ruleForm: {
        name: [
          { required: true, message: this.$t('account.login.uidPlaceholder'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('account.login.pwdPlaceholder'), trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$root.$on('clearFormCloseModal', () => {
        this.$refs['form'] && this.$refs['form'].resetFields()
      })
    })
  },
  methods: {
    ok () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.isSubmit) {
            this.$Loading.start()
            this.isSubmit = true
            this.isShowLoader = true
            this.$api.account.login({
              name: this.form.name,
              password: this.form.password,
              remember: this.form.remember ? 1 : 0,
              source: 'app',
              platform: 'pc'
            }, {
              success: (response) => {
                this.$Loading.finish()
                this.isSubmit = false
                this.isShowLoader = false
                if (response.data.code === 200) {
                  this.isShowModal(false)
                  this.setUserInfo({
                    id: response.data.data.id,
                    name: response.data.data.name,
                    gender: response.data.data.gender,
                    portrait: response.data.data.portrait || '',
                    token: response.data.data.token,
                    vip: response.data.data.vip || ''
                  })
                  if (response.data.data.setting) {
                    this.setSettings({
                      data: {
                        integralSwitch: response.data.data.setting.integralSwitch || 0,
                        instructionSwitch: response.data.data.setting.instructionSwitch || 0
                      }
                    })
                  }
                  this.$refs['form'].resetFields()
            
                  if (this.$route.query.redirect) {
                  
                    this.$router.push(this.$route.query.redirect)
                  } else if (this.$route.query.backurl) {
                    this.$router.push(this.$route.query.backurl)
                  } else {
                    this.$router.replace({path: '/'})
                  }
                } else if (this._.indexOf([200200, 200204], response.data.code) !== -1) {
                  this.$Message.error({content: this.$t('account.login.userOrPwdError'), closable: true})
                } else if (response.data.code === 200306 || response.data.code === 200308) {
                  this.$Message.error({content: this.$t('account.login.accountDisable'), closable: true})
                } else if (response.data.code === 200307) {
                  this.$Message.error({content: this.$t('account.login.accountAuditing'), closable: true})
                } else if (response.data.code === 200309) {
                  this.$Message.error({content: this.$t('account.login.accountNotActivation'), closable: true})
                } else {
                  this.$Message.error({content: this.$t('account.login.loginErrorAgain'), closable: true})
                }
              },
              error: (errorMsg) => {
                this.$Loading.error()
                this.isSubmit = false
                this.isShowLoader = false
                this.$Message.error({content: this.$t('account.login.loginError'), closable: true})
              }
            })
          }
        }
      })
    },
    ...mapMutations({
      isShowModal: 'account/setModalState',
      setUserInfo: 'account/setUserInfo',
      setSettings: 'account/setSettingState'
    })
  }
}
</script>
<style scoped>
  .form-icon.pwd{
    background-image: url("~@/assets/images/icons/account/pwd.png");
  }
  .signin-box .footer{
    margin-top: 10px;
  }
  .ivu-form-item.pwd{
    margin-bottom: 8px;
  }
  .ivu-form-item.pwd.ivu-form-item-error{
    margin-bottom: 20px;
  }
  .ivu-form-item:last-child{
    margin-bottom: 10px;
  }
  .forgotpwd{
    font-size: 1.3rem;
    color: #1F8AFD;
    float: right;
  }
  .regbox{
    font-size: 1.3rem;
    margin: 15px 0 10px;
    color: #999;
    padding-left: 2px;
  }
  .regbox a{
    color: #1F8AFD;
  }
  .signin-box >>> .loading .wrap{
    top: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/zh-CN/Login.vue